export default {
    "Data Record": "Data Record",
    "My Storage": "My Storage",
    "Upgrade": "Upgrade",
    "Data Size": "Data Size",
    "Folders": "Folder",
    "Your file is getting upload": "File is Uploading",
    "Folder Name": "Folder Name",
    "Files": "File",
    "Rename Folder": "Rename Folder",
    "Move Folder": "Move Folder",
    "Delete Folder": "Delete Folder",
    "Upload": "Upload",
    "Create Folder": "Create Folder",
    "Uploading": "Uploading",
    "Cancel Uploading": "Cancel Uploading",
    "Are you sure want to cancel ?": "Are you sure you want to cancel?",
    "Yes": "Yes",
    "No": "No",
    "Are you sure want to delete ?": "Are you sure you want to delete?",
    "Cancel": "Cancel",
    "Delete": "Delete",
    "Rename Folder/File": "Rename Folder/File",
    "Folder  Name / File Name": "Folder Name/File Name",
    "Save": "Save",
    "Move File": "Move File",
    "Move": "Move",
    "Share": "Share",
    "Rename": "Rename",
    "Delete": "Delete",
    "Download": "Download",
    "No Data Found": "No Data Found",
    "Search": "Search...",
    "uploaded successfully": "Uploaded",
    "You can share one file at a time": "Please share one file at a time",
    "Choose your folder and click on move here": "Select a folder and press Move File",
    "You can download one file at time": "You can download one file at a time",
    "you can rename one file at a time": "You can rename one file at a time",
    "Rename successfull": "File Renamed",
    "file Deleted Successfully": "File Deleted",
    "Load More": "Load More",
    "No more Data": "No more Data",
    "Insufficient Memory": "you do not have sufficient space"
}
